const DashboardSvg = ({
  height = 22,
  width = 22,
  viewBox = '0 0 22 20',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox}>
      <path
        d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM16.1172 15.1523C17.0884 14.0004 17.7395 12.5716 17.9355 11H12.2842L16.1172 15.1523ZM11 9H17.9355C17.4842 5.3815 14.6185 2.51479 11 2.06348V9ZM2 10C2 14.4183 5.58172 18 10 18C11.7338 18 13.3372 17.446 14.6475 16.5088L9.26562 10.6787C9.09511 10.494 9 10.2514 9 10V2.06348C5.05378 2.55566 2 5.92045 2 10Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default DashboardSvg;
